<template>
  <label class="m-form-radio">
    <input class="checkbox" type="radio" :checked="isChecked" :disabled="disabled" :value="value" @change="$emit('change', $event.target.value)" />
    {{label}}
  </label>
</template>

<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    "label": { 
      type: String,
      default: "",
      required:true
    },
    "modelValue": { 
      default: ""
    },
    "value": { 
      type: String,
      default: undefined
    },
    "disabled": { 
      type: Boolean,
      default: false
    }
  },
  computed: {
    isChecked() {
      return this.modelValue == this.value
    }
  }
}
</script>

<style lang="scss"></style>
